// A3.22 — Risk skori adapter. Module-local. Read-only agregat (strike/report/
// related/ban signallari → 0–100 ball + daraja). Migratsiyasiz.
import { api } from '@/lib/api'

export interface RiskSignals {
  active_strike_points: number
  reports_total: number
  reports_pending: number
  related_accounts: number
  is_banned: boolean
}

export interface UserRisk {
  score: number
  level: 'low' | 'medium' | 'high'
  signals: RiskSignals
}

export async function fetchUserRisk(userId: number, signal?: AbortSignal): Promise<UserRisk> {
  return api.get<UserRisk>(`/admin/users/${userId}/risk`, signal ? { signal } : {})
}
